'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Shelves;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Shelves(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-shelves ' + className,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M13.6667341,3.73254543 L10.9524689,4.27768449 L10.7228047,3.13369246 C10.7045229,3.04455022 10.7730794,2.93883667 10.8616315,2.92112251 L13.2353996,2.44398298 C13.324523,2.42626881 13.4193595,2.49941116 13.4370699,2.5885534 L13.6667341,3.73254543 Z M15.6177373,13.4490492 L12.903472,13.9947597 L11.1027218,5.02796497 L13.8175584,4.48282592 L15.6177373,13.4490492 Z M13.0537249,14.7444687 L15.7685615,14.1993297 L15.9970831,15.3393217 C16.0147935,15.4278925 15.9496649,15.5010349 15.8611128,15.518749 L13.4873447,15.9958886 C13.3982213,16.0136027 13.3005283,15.973603 13.2828179,15.8850322 L13.0537249,14.7444687 Z M10.0178155,1.93084369 L5.97412586,1.93084369 L5.97412586,0.230855535 C5.97412586,0.110856371 6.05639364,0 6.17636747,0 L9.7847235,0 C9.90469734,0 10.0178155,0.110856371 10.0178155,0.230855535 L10.0178155,1.93084369 Z M5.97412586,2.69598122 L10.0178155,2.69598122 L10.0178155,13.9181888 L5.97412586,13.9181888 L5.97412586,2.69598122 Z M5.97412586,14.6838977 L10.0178155,14.6838977 L10.0178155,15.7964614 C10.0178155,15.917032 9.90469734,15.9953171 9.7847235,15.9953171 L6.17636747,15.9953171 C6.05639364,15.9953171 5.97412586,15.917032 5.97412586,15.7964614 L5.97412586,14.6838977 Z M4.69897535,3.27940573 L0,3.27940573 L0,1.59598888 C0,1.47541829 0.091979943,1.38456178 0.211953782,1.38456178 L4.48016592,1.38456178 C4.60013976,1.38456178 4.69897535,1.47541829 4.69897535,1.59598888 L4.69897535,3.27940573 Z M0,4.00797208 L4.69954665,4.00797208 L4.69954665,13.9187602 L0,13.9187602 L0,4.00797208 Z M0,14.6838977 L4.69897535,14.6838977 L4.69897535,15.7964614 C4.69897535,15.917032 4.60013976,15.9953171 4.48016592,15.9953171 L0.211953782,15.9953171 C0.091979943,15.9953171 0,15.917032 0,15.7964614 L0,14.6838977 Z' })
  );
}

Shelves.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Shelves/Shelves.js
// module id = 317
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15